import {
  PaymentIntent,
  PaymentIntentResult,
  PaymentMethod,
  SetupIntent,
  SetupIntentResult,
} from '@stripe/stripe-js';

export const getPaymentIntentIdFromResponse = (
  stripeResponse: PaymentIntentResult | SetupIntentResult
): string | null => {
  return (stripeResponse as PaymentIntentResult)?.paymentIntent?.id ?? null;
};
export const getSetupIntentIdFromResponse = (
  stripeResponse: PaymentIntentResult | SetupIntentResult
): string | null => {
  return (stripeResponse as SetupIntentResult)?.setupIntent?.id ?? null;
};

export const getIntentFromResponse = (
  stripeResponse: PaymentIntentResult | SetupIntentResult
): PaymentIntent | SetupIntent | undefined => {
  return (
    (stripeResponse as PaymentIntentResult)?.paymentIntent ??
    (stripeResponse as SetupIntentResult)?.setupIntent
  );
};

export const getPaymentMethodIdFromIntent = (
  intent: PaymentIntent | SetupIntent
): string | null => {
  if (typeof intent.payment_method === 'string') {
    return intent.payment_method;
  }
  if (typeof intent.payment_method === 'object' && intent.payment_method?.id) {
    return intent.payment_method.id;
  }
  return null;
};

export const getPaymentMethodObject = (
  intent: PaymentIntent | SetupIntent
): PaymentMethod | null => {
  return typeof intent.payment_method === 'object'
    ? intent.payment_method
    : null;
};

export const getCardBrandFromPaymentMethod = (
  paymentMethod: PaymentMethod | null
): string => {
  if (paymentMethod) {
    if (paymentMethod.card) {
      return paymentMethod.card.wallet?.type ?? paymentMethod.card.brand;
    }
    return paymentMethod.type;
  }
  return '';
};

export const getCardLast4FromPaymentMethod = (
  paymentMethod: PaymentMethod | null
): string => {
  if (paymentMethod?.card?.wallet) {
    return '';
  }
  return paymentMethod?.card?.last4 ?? '';
};

export const formatExpirationValue = (
  value: number | string | null,
  isMonth?: boolean
): string => {
  if (!value) {
    return '';
  }
  return isMonth ? `0${value}`.slice(-2) : `20${value}`.slice(-4);
};

export const getCardExpDateFromPaymentMethod = (
  paymentMethod: PaymentMethod | null
): { expMonth: string; expYear: string } => {
  const expDateResponse = {
    expMonth: '',
    expYear: '',
  };
  if (paymentMethod?.card && !paymentMethod.card.wallet) {
    expDateResponse.expMonth = formatExpirationValue(
      paymentMethod.card.exp_month,
      true
    );
    expDateResponse.expYear = formatExpirationValue(
      paymentMethod.card.exp_year
    );
  }
  return expDateResponse;
};
